import { createApp, defineAsyncComponent } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as Icons from '@element-plus/icons-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import 'dayjs/locale/zh-cn'
import locale from 'element-plus/es/locale/lang/zh-cn'
import { QuillEditor } from '@vueup/vue-quill'
import '@vueup/vue-quill/dist/vue-quill.snow.css'


import { setupVab } from '@vab/setup'
import { setupStore } from '@/store'
import { setupRouter } from '@/router'

// 全局捕获 ElMessageBox 取消操作产生的 Promise rejection
window.addEventListener('unhandledrejection', (e) => {
  if (e.reason === 'cancel' || e.reason === 'close') {
    e.preventDefault()
  }
})

// 全局捕获 ResizeObserver 错误（浏览器已知问题，不影响功能）
// 方法1: 捕获error事件
window.addEventListener('error', (e) => {
  if (e.message && e.message.includes('ResizeObserver')) {
    const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay')
    if (resizeObserverErrDiv) {
      resizeObserverErrDiv.style.display = 'none'
    }
    e.stopImmediatePropagation()
    e.preventDefault()
    return false
  }
})

// 方法2: 拦截ResizeObserver
const _ResizeObserver = window.ResizeObserver
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback) {
    callback = (entries, observer) => {
      window.requestAnimationFrame(() => {
        callback(entries, observer)
      })
    }
    super(callback)
  }
}

const app = createApp(App)
Object.keys(Icons).forEach((key) => {
  app.component(key, Icons[key])
})
app.component(
  'ybDialog',
  defineAsyncComponent(() => import('@/components/ybDialog'))
)
app.component('QuillEditor', QuillEditor)
app.use(store).use(router).use(ElementPlus, { locale }).mount('#app')

setupVab(app)
setupStore(app)
setupRouter(app)
